/**
 * CAGED scale-box windows used by the Scales tab.
 *
 * The chord-fingering generator that previously lived in this file retired in v1.2;
 * chord shapes now come from the chord library (utils/chordLibrary.ts).
 *
 * What stays here is the scale-box window data, which is independent of fingering
 * generation and still drives the Scales-tab CAGED letter selector.
 */

export type CagedLetter = 'C' | 'A' | 'G' | 'E' | 'D';

/**
 * CAGED scale-box windows for KEY OF C with each shape at its canonical position.
 * For other keys, see utils/cagedWindow.ts which transposes from this base.
 *
 * Source: Justin Sandercoe's CAGED system reference, cross-referenced with
 * Truefire's CAGED essentials. The C-key E-shape window [7, 10] follows
 * pedagogical convention.
 */
export const CAGED_OFFSETS_FOR_C_KEY: Record<CagedLetter, [number, number]> = {
  C: [0, 3],
  A: [3, 6],
  G: [5, 8],
  E: [7, 10],
  D: [9, 12],
};
